import React from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { withRouter } from 'react-router-dom'

import { PageTitle } from 'Components/PageTitle'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { CityAddEditWrapper } from 'Components/City/CityAddEdit/Wrapper'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { PATHS } from 'Config/Routing/paths'
import CitiesIcons from 'Assets/Images/icons/cities'
import AddCityDetails from './../../../Containers/Form/City/CityAddEdit/Add/AddCityDetails/Controller'

const CityAdd = props => (
  <HideWhenBlocked>
    <CityAddEditWrapper>
      <LayoutDashboard>
        <div>
          <Breadcrumbs icon={<CitiesIcons style={{ width: 16 }} />} />
          <Breadcrumb
            data={{
              title: 'Cities',
              pathname: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
            }}
          />
          <Breadcrumb data={{ title: 'Create', pathname: props.match.url }} />
        </div>
        <PageTitle>Create City</PageTitle>
        <AddCityDetails {...props} />
      </LayoutDashboard>
    </CityAddEditWrapper>
  </HideWhenBlocked>
)

export default withRouter(CityAdd)



// WEBPACK FOOTER //
// ./src/Containers/City/CityAdd/index.js